//analytics
import { IMPRESSION_ACTIONS, CLICK_ACTIONS, SCREEN_NAME, LABELS } from "@payment-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/analytics";

export const clickViewAllBtn = (context: string, clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({ category: SCREEN_NAME.PAYMENT, action: CLICK_ACTIONS.CLICK_VIEW_ALL, context });
};

export const impressionViewAll = (impressionEvent: AnalyticsContextValue["impressionEvent"]): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        action: IMPRESSION_ACTIONS.IMPRESSION_VIEW_ALL,
    });
};

export const clickAddNew = (value: string, clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({ category: SCREEN_NAME.PAYMENT, action: CLICK_ACTIONS.CLICK_ADD_NEW, value });
};

export const impressionAddNew = (impressionEvent: AnalyticsContextValue["impressionEvent"]): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        action: IMPRESSION_ACTIONS.IMPRESSION_ADD_NEW,
    });
};

export const clickPaymentGroups = (
    context: string,
    label: string,
    value: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        action: CLICK_ACTIONS.CLICK_PAYMENT_GROUPS,
        label: label,
        context: JSON.stringify(context),
        value: value,
    });
};

export const clickInAppOnBoarding = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        action: CLICK_ACTIONS.CLICK_PAYMENT_ADD_ONE_TAP,
        label: LABELS.ONE_TAP_UPI,
    });
};

export const impressionPaymentGroups = (
    methodList: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        action: IMPRESSION_ACTIONS.IMPRESSION_PAYMENT_GROUPS,
        label: methodList,
    });
};

export const impressionPaymentGroupsExpanded = (
    methodList: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        action: IMPRESSION_ACTIONS.IMPRESSION_PAYMENT_GROUPS_EXPANDED,
        label: methodList,
    });
};
